export const filterShops = (shops, search) =>
  shops?.filter((shop) =>
    shop?.users?.some((user) => user?.toLowerCase().includes(search))
      ? shop
      : shop?.shopId?.toString().includes(search) || shop?.name?.toLowerCase().includes(search)
  );
